import React from 'react';
import { XIcon } from 'lucide-react';
import { pains } from '../data/salesCopy';
export function ProblemSection() {
  return <section className="w-full border-b border-line bg-paper" data-id="element-183" data-mp="2ltmgzr0xdnkj">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-5 sm:py-16 lg:py-20" data-id="element-184" data-mp="30hpq39a9lfdk">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-185" data-mp="2vqhfwb141pzc">
          <div data-id="element-186" data-mp="2voo82sergzpr">
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-rust sm:text-xs" data-id="element-187" data-mp="39hw36u21wdc7">
              The reality of teaching music
            </p>
            <h2 className="mt-3 font-display text-2xl font-semibold leading-tight tracking-tight text-ink sm:mt-4 sm:text-4xl" data-id="element-188" data-mp="35g0zxk0k7pvs">
              Does this sound like you?
            </h2>
            <p className="mt-4 font-display text-lg font-medium leading-snug text-ink-soft sm:mt-5 sm:text-2xl" data-id="element-189" data-mp="3eia8w5g6jb72">
              How much longer are you willing to improvise every lesson?
            </p>
            <p className="mt-4 max-w-md text-[15px] leading-relaxed text-ink-muted sm:mt-5 sm:text-base" data-id="element-190" data-mp="1k4irgjrlzn12">
              We get it. You should be spending your time teaching and changing lives — not stuck
              behind a screen formatting worksheets.
            </p>
          </div>

          <ul className="divide-y divide-line border-y border-line" data-id="element-191" data-mp="sd0585nwoacz">
            {pains.map(pain => <li key={pain} className="flex items-start gap-3 py-3.5 sm:gap-4 sm:py-4" data-id="element-192" data-mp="x5be3y0mj6ho">
                <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-rust" aria-hidden="true" data-id="element-193" data-mp="122jsdniniqdn" />
                <span className="text-[15px] leading-relaxed text-ink-soft sm:text-base" data-id="element-194" data-mp="171mvh2f2mmiz">
                  {pain}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}